// apps/vendor/src/features/products/variantCost.ts
//
// 2026-10-14 (plan D13) — FE mirror of the API helper
// `apps/api/src/modules/vendor/services/variantCost.ts`: the cost of one
// vendor SKU is its own `cost_cents` when the file import set one, else the
// product base + the variant markup. Vendor's OWN cost only — never a tier (D3).

export function variantCostCents(
  product: { cost_price_cents?: number | null } | null | undefined,
  v: { cost_cents?: number | null; cost_markup_cents?: number | null } | null | undefined,
): number {
  const own = v?.cost_cents;
  if (typeof own === 'number' && Number.isFinite(own)) return own;
  return (product?.cost_price_cents ?? 0) + (v?.cost_markup_cents ?? 0);
}

/** D16a — a product priced per SKU: at least one variant carries cost_cents. */
export function hasPerSkuCost(variants: ReadonlyArray<{ cost_cents?: number | null }>): boolean {
  return variants.some((v) => typeof v.cost_cents === 'number');
}

/** min / max effective cost across variants; null when there are none. */
export function variantCostRange(
  product: { cost_price_cents?: number | null } | null | undefined,
  variants: ReadonlyArray<{ cost_cents?: number | null; cost_markup_cents?: number | null }>,
): { min: number; max: number } | null {
  if (variants.length === 0) return null;
  let min = Infinity;
  let max = -Infinity;
  for (const v of variants) {
    const c = variantCostCents(product, v);
    if (c < min) min = c;
    if (c > max) max = c;
  }
  return { min, max };
}
